"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprayApplicationResponseRowToJSON = exports.SprayApplicationResponseRowFromJSONTyped = exports.SprayApplicationResponseRowFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function SprayApplicationResponseRowFromJSON(json) {
    return SprayApplicationResponseRowFromJSONTyped(json, false);
}
exports.SprayApplicationResponseRowFromJSON = SprayApplicationResponseRowFromJSON;
function SprayApplicationResponseRowFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': !runtime_1.exists(json, 'date') ? undefined : json['date'],
        'field': !runtime_1.exists(json, 'field') ? undefined : json['field'],
        'product': !runtime_1.exists(json, 'product') ? undefined : (json['product'].map(_1.SprayAppDetailsFromJSON)),
        'acres': !runtime_1.exists(json, 'acres') ? undefined : json['acres'],
        'notes': !runtime_1.exists(json, 'notes') ? undefined : json['notes'],
    };
}
exports.SprayApplicationResponseRowFromJSONTyped = SprayApplicationResponseRowFromJSONTyped;
function SprayApplicationResponseRowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'field': value.field,
        'product': value.product === undefined ? undefined : (value.product.map(_1.SprayAppDetailsToJSON)),
        'acres': value.acres,
        'notes': value.notes,
    };
}
exports.SprayApplicationResponseRowToJSON = SprayApplicationResponseRowToJSON;
